import {
  billOfMaterialsIdFormat,
  billOfMaterialsLocationIdFormat,
  locationIdFormat,
} from "@redotech/redo-ids/ids";
import * as z from "zod";

const BillOfMaterialsLocation_ = z.object({
  id: billOfMaterialsLocationIdFormat.schema,
  bomId: billOfMaterialsIdFormat.schema,
  locationId: locationIdFormat.schema,
  locationName: z.string(),
  enabled: z.boolean(),
  buildable: z.number().int(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export const BillOfMaterialsLocation: z.ZodType<BillOfMaterialsLocation> =
  BillOfMaterialsLocation_;
export interface BillOfMaterialsLocation extends z.infer<
  typeof BillOfMaterialsLocation_
> {}
